module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('Menu', {
    ref: "sideMenu",
    attrs: {
      "active-name": _vm.$route.name,
      "open-names": ['1', '2'],
      "theme": _vm.$store.state.menuTheme,
      "width": "135"
    },
    on: {
      "on-select": _vm.changeMenu
    }
  }, [_vm._l((_vm.menuList), function(item) {
    return [(item.children.length <= 1 && (!item.menuAccess || item.menuAccess.indexOf(_vm.access) != -1)) ? _c('MenuItem', {
      key: item.path,
      staticStyle: {
        "padding-left": "15px"
      },
      attrs: {
        "name": item.children[0].name
      },
      nativeOn: {
        "click": function($event) {
          return _vm.handleMenuItemClick(item)
        }
      }
    }, [(item.title == '春季促销') ? _c('span', {
      staticClass: "promotion"
    }, [_vm._v("促销")]) : _vm._e(), _vm._v(" "), _c('i', {
      class: 'iconfont ' + item.icon,
      style: ('font-size:' + _vm.iconSize + 'px')
    }), _vm._v(" "), _c('span', {
      staticClass: "layout-text"
    }, [_vm._v(_vm._s(_vm.itemTitle(item)) + "\n                    "), _c('Badge', {
      staticStyle: {
        "width": "100%",
        "position": "absolute",
        "top": "3px",
        "left": "0"
      },
      attrs: {
        "dot": "",
        "count": _vm.feeMenuBadge(item)
      }
    }), _vm._v(" "), (item.title == '我的订单' && _vm.canEvaluate) ? _c('Badge', {
      staticStyle: {
        "width": "100%",
        "position": "absolute",
        "top": "3px",
        "left": "0"
      },
      attrs: {
        "dot": ""
      }
    }) : _vm._e()], 1)]) : _vm._e(), _vm._v(" "), (item.children.length > 1) ? _c('Submenu', {
      key: item.title,
      attrs: {
        "name": item.name
      }
    }, [_c('template', {
      slot: "title"
    }, [_c('Badge', {
      staticStyle: {
        "width": "100%"
      },
      attrs: {
        "dot": "",
        "count": _vm.feeMenuBadge(item)
      }
    }, [_c('i', {
      class: 'iconfont ' + item.icon,
      style: ('font-size:' + _vm.iconSize + 'px')
    }), _vm._v(" "), _c('span', {
      staticClass: "layout-text"
    }, [_vm._v(_vm._s(_vm.itemTitle(item)))])])], 1), _vm._v(" "), _vm._l((item.children), function(child) {
      return [_c('MenuItem', {
        key: child.name,
        attrs: {
          "name": child.name
        }
      }, [_c('i', {
        class: 'iconfont ' + item.icon,
        style: ('font-size:' + _vm.iconSize + 'px')
      }), _vm._v(" "), _c('span', {
        key: child.name,
        staticClass: "layout-text"
      }, [_vm._v(_vm._s(child.title))])])]
    })], 2) : _vm._e()]
  })], 2)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-loader/node_modules/vue-hot-reload-api").rerender("data-v-670915fb", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-670915fb"}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/iview-loader?{"prefix":false}!./src/views/main_components/sidebarMenu.vue
// module id = 1315
// module chunks = 61